export const getAllWords = (text: string) => {
  return [...new Set(text.toLowerCase().match(/\w+/g) || [])];
};
